// ============================================================
// Sample newsfeed for the showcase (demoMode).
//
// The Feed tab is one of the first things anyone taps in a demo, and with
// API traffic blocked it renders "No posts yet" — which reads as a broken or
// unused feature rather than a deliberate sample.
//
// Posts cover the filter chips the feed offers (Announcement, Webinar,
// Event, News, Update, Investment) so tapping a filter never lands on an
// empty list. Both languages are filled: the feed picks titleDe/contentDe
// when the app is in German, and an untranslated post would show English
// text to a DACH audience mid-demo.
//
// Content is deliberately generic company news — nothing that names a real
// investor, a real deal value, or a real counterparty.
// ============================================================

/** Days-ago helper: keeps the feed looking current without hardcoded dates. */
function daysAgo(n: number): string {
  return new Date(Date.now() - n * 24 * 60 * 60 * 1000).toISOString();
}

export const DEMO_FEED_POSTS: any[] = [
  {
    id: 'demo-post-1',
    type: 'announcement',
    author: 'Asset Desk',
    title: 'Asset Desk now values every unit from DLD data',
    titleDe: 'Asset Desk bewertet jetzt jede Einheit anhand von DLD-Daten',
    content:
      'Your portfolio now carries a market valuation for each unit, built from registered Dubai Land Department transactions and Ejari contracts rather than an estimate. Open Portfolio ▸ Valuation and tap a property to see the comparable sales behind the number, including the official DLD reference of each transaction.',
    contentDe:
      'Ihr Portfolio enthält jetzt für jede Einheit eine Marktbewertung, die auf registrierten Transaktionen des Dubai Land Department und Ejari-Verträgen basiert — keine Schätzung. Öffnen Sie Portfolio ▸ Bewertung und tippen Sie auf eine Immobilie, um die Vergleichsverkäufe hinter der Zahl zu sehen, inklusive der offiziellen DLD-Referenz jeder Transaktion.',
    imageUrls: [],
    actionLabel: 'Open Portfolio',
    actionUrl: null,
    actionLabel2: null,
    actionUrl2: null,
    commentsEnabled: true,
    pinned: true,
    likes: [],
    comments: [],
    viewCount: 214,
    createdAt: daysAgo(2),
  },
  {
    id: 'demo-post-2',
    type: 'announcement',
    author: 'Asset Desk',
    title: 'Service charge invoices for Q3 are in your Documents',
    titleDe: 'Servicegebühren-Rechnungen für Q3 liegen in Ihren Dokumenten',
    content:
      'Q3 service charge invoices have been filed against each unit and are available under Documents. Payment is due within 30 days of the invoice date. If a unit is under our management, the charge is settled from the rent account and shown on your next statement instead.',
    contentDe:
      'Die Servicegebühren-Rechnungen für Q3 wurden den jeweiligen Einheiten zugeordnet und sind unter Dokumente verfügbar. Die Zahlung ist innerhalb von 30 Tagen ab Rechnungsdatum fällig. Bei Einheiten in unserer Verwaltung wird die Gebühr aus dem Mietkonto beglichen und erscheint stattdessen auf Ihrer nächsten Abrechnung.',
    imageUrls: [],
    actionLabel: null,
    actionUrl: null,
    actionLabel2: null,
    actionUrl2: null,
    commentsEnabled: true,
    pinned: false,
    likes: [],
    comments: [],
    viewCount: 168,
    createdAt: daysAgo(6),
  },
  {
    id: 'demo-post-3',
    type: 'webinar',
    author: 'Asset Desk',
    title: 'Webinar: Dubai rental yields going into 2027',
    titleDe: 'Webinar: Mietrenditen in Dubai mit Blick auf 2027',
    content:
      'A 45-minute session on where rents moved this year by community, what the Ejari data shows about renewals versus new contracts, and how that feeds into the yield figures you see in Asset Desk. Held in German, with questions at the end.',
    contentDe:
      'Eine 45-minütige Session dazu, wie sich die Mieten in diesem Jahr je Community entwickelt haben, was die Ejari-Daten über Verlängerungen im Vergleich zu Neuverträgen zeigen und wie das in die Renditezahlen in Asset Desk einfließt. Auf Deutsch, mit Fragen am Ende.',
    imageUrls: [],
    actionLabel: 'Reserve a place',
    actionUrl: null,
    actionLabel2: null,
    actionUrl2: null,
    commentsEnabled: true,
    pinned: false,
    likes: [],
    comments: [],
    viewCount: 97,
    createdAt: daysAgo(9),
  },
  {
    id: 'demo-post-4',
    type: 'construction',
    author: 'Asset Desk',
    title: 'Construction update: Damac Bay 2 passes 60%',
    titleDe: 'Baufortschritt: Damac Bay 2 überschreitet 60 %',
    content:
      'The developer has reported structural works complete to level 38 and facade installation underway on the lower floors. Overall completion stands at 62%, in line with the handover window in your unit timeline. The next escrow milestone is scheduled for the coming quarter.',
    contentDe:
      'Der Entwickler meldet den Rohbau bis Ebene 38 als abgeschlossen; die Fassadenmontage in den unteren Geschossen läuft. Der Gesamtfortschritt liegt bei 62 % und damit im Rahmen des Übergabezeitraums in Ihrer Einheiten-Timeline. Der nächste Escrow-Meilenstein ist für das kommende Quartal geplant.',
    imageUrls: [],
    actionLabel: null,
    actionUrl: null,
    actionLabel2: null,
    actionUrl2: null,
    commentsEnabled: true,
    pinned: false,
    likes: [],
    comments: [],
    viewCount: 131,
    createdAt: daysAgo(13),
  },
  {
    id: 'demo-post-5',
    type: 'news',
    author: 'Asset Desk',
    title: 'DLD: Dubai transaction volumes up again this quarter',
    titleDe: 'DLD: Transaktionsvolumen in Dubai erneut gestiegen',
    content:
      'Registered sales rose across most communities this quarter, with off-plan continuing to make up the larger share. Mina Rashid and Dubai Harbour both saw a higher median price per square foot than the same quarter last year. The figures behind your own valuations update as these registrations land.',
    contentDe:
      'Die registrierten Verkäufe sind in diesem Quartal in den meisten Communities gestiegen, wobei Off-Plan weiterhin den größeren Anteil ausmacht. In Mina Rashid und Dubai Harbour lag der mittlere Preis pro Quadratfuß über dem Vorjahresquartal. Die Zahlen hinter Ihren eigenen Bewertungen aktualisieren sich, sobald diese Registrierungen eingehen.',
    imageUrls: [],
    actionLabel: null,
    actionUrl: null,
    actionLabel2: null,
    actionUrl2: null,
    commentsEnabled: false,
    pinned: false,
    likes: [],
    comments: [],
    viewCount: 245,
    createdAt: daysAgo(17),
  },
  {
    id: 'demo-post-6',
    type: 'event',
    author: 'Asset Desk',
    title: 'Investor evening in Munich',
    titleDe: 'Investorenabend in München',
    content:
      'An informal evening for our DACH investors: a short market update, then time to talk through your own portfolio with the team one to one. Places are limited and allocated in order of registration.',
    contentDe:
      'Ein informeller Abend für unsere DACH-Investoren: ein kurzes Marktupdate, danach Zeit, Ihr eigenes Portfolio im Einzelgespräch mit dem Team durchzugehen. Die Plätze sind begrenzt und werden in der Reihenfolge der Anmeldungen vergeben.',
    imageUrls: [],
    actionLabel: 'Register',
    actionUrl: null,
    actionLabel2: null,
    actionUrl2: null,
    commentsEnabled: true,
    pinned: false,
    likes: [],
    comments: [],
    viewCount: 76,
    createdAt: daysAgo(24),
  },
  {
    id: 'demo-post-7',
    type: 'tip',
    author: 'Asset Desk',
    title: 'New release: waterfront one-bedrooms at Dubai Islands',
    titleDe: 'Neu im Angebot: Ein-Zimmer-Wohnungen am Wasser auf Dubai Islands',
    content:
      'A limited release of one-bedroom units with a 60/40 payment plan and handover indicated for 2028. Sample sizes run from 720 to 810 sqft. Ask your contact for the full price list and the DLD comparables for the surrounding area before deciding.',
    contentDe:
      'Ein begrenztes Angebot an Ein-Zimmer-Einheiten mit einem 60/40-Zahlungsplan und Übergabe voraussichtlich 2028. Die Größen liegen zwischen 720 und 810 sqft. Fragen Sie Ihren Ansprechpartner nach der vollständigen Preisliste und den DLD-Vergleichswerten für die Umgebung, bevor Sie entscheiden.',
    imageUrls: [],
    actionLabel: 'Request details',
    actionUrl: null,
    actionLabel2: null,
    actionUrl2: null,
    commentsEnabled: true,
    pinned: false,
    likes: [],
    comments: [],
    viewCount: 189,
    createdAt: daysAgo(31),
  },,
  {
    id: 'demo-post-8',
    type: 'update',
    author: 'Asset Desk',
    title: 'The app now speaks German throughout',
    titleDe: 'Die App ist jetzt vollständig auf Deutsch',
    content:
      'Every screen, report and email is now available in German — switch language from the selector at the top of the app and the choice follows you across every tab, including the downloadable valuation report.',
    contentDe:
      'Alle Ansichten, Berichte und E-Mails sind jetzt auf Deutsch verfügbar — wechseln Sie die Sprache über die Auswahl am oberen Rand der App; die Einstellung gilt anschließend in allen Bereichen, auch im herunterladbaren Bewertungsbericht.',
    imageUrls: [],
    actionLabel: null,
    actionUrl: null,
    actionLabel2: null,
    actionUrl2: null,
    commentsEnabled: true,
    pinned: false,
    likes: [],
    comments: [],
    viewCount: 152,
    createdAt: daysAgo(20),
  },

  // ---- Construction updates, one per project in the portfolio ------------
  // An off-plan owner's single most-asked question is "how is my building
  // going". The feed is where that belongs: a dated update per project, with
  // the same percentage the unit card and the timeline show, so the three
  // never disagree. Photos reuse the project imagery the app already ships.
  {
    id: 'demo-post-update-nautica',
    type: 'update',
    author: 'Asset Desk · Project Monitoring',
    title: 'Nautica Two — 97% complete, handover next month',
    titleDe: 'Nautica Two — 97% fertig, Übergabe im nächsten Monat',
    content:
      'Structural work and facade are finished and the tower is in final fit-out: lifts commissioned, common areas being snagged. The developer has confirmed handover for next month. We attend the snagging inspection for every unit we manage, send you the defect list with photographs, and hold the developer to the fixes before you accept the keys.',
    contentDe:
      'Rohbau und Fassade sind fertig, der Turm ist im finalen Ausbau: Aufzüge abgenommen, Gemeinschaftsflächen in der Mängelprüfung. Der Entwickler hat die Übergabe für den nächsten Monat bestätigt. Wir nehmen die Abnahme für jede von uns verwaltete Einheit wahr, senden Ihnen die Mängelliste mit Fotos und halten den Entwickler zur Behebung an, bevor Sie die Schlüssel annehmen.',
    imageUrls: ['https://i.imgur.com/4lNc5Zb.jpeg'],
    actionLabel: null,
    actionUrl: null,
    actionLabel2: null,
    actionUrl2: null,
    commentsEnabled: true,
    pinned: false,
    likes: [],
    comments: [],
    viewCount: 96,
    createdAt: daysAgo(1),
  },
  {
    id: 'demo-post-update-damac',
    type: 'update',
    author: 'Asset Desk · Project Monitoring',
    title: 'Damac Bay 2 — 62% complete, on programme',
    titleDe: 'Damac Bay 2 — 62% fertig, im Zeitplan',
    content:
      'The tower has topped out and the facade is climbing floor by floor; MEP first fix is running behind it. The escrow account and the construction milestones are matching the payment plan, which is what keeps your instalments tied to progress rather than to the calendar. Completion is still stated for Q3 2027.',
    contentDe:
      'Der Turm hat die Endhöhe erreicht, die Fassade wächst Etage für Etage, dahinter läuft die MEP-Erstinstallation. Treuhandkonto und Baufortschritt stimmen mit dem Zahlungsplan überein — das hält Ihre Raten an den Fortschritt gebunden und nicht an den Kalender. Die Fertigstellung ist weiterhin für Q3 2027 angegeben.',
    imageUrls: ['https://i.imgur.com/mx8T6K3.jpeg'],
    actionLabel: null,
    actionUrl: null,
    actionLabel2: null,
    actionUrl2: null,
    commentsEnabled: true,
    pinned: false,
    likes: [],
    comments: [],
    viewCount: 74,
    createdAt: daysAgo(4),
  },
  {
    id: 'demo-post-update-clearpoint',
    type: 'update',
    author: 'Asset Desk · Project Monitoring',
    title: 'Clearpoint Building 3 — 31% complete, podium poured',
    titleDe: 'Clearpoint Building 3 — 31% fertig, Podium betoniert',
    content:
      'The podium slab is poured and the tower cores are rising. The next construction milestone triggers an instalment; we check it against the DLD project registry before anything is due, so you are never asked for a payment the build has not earned.',
    contentDe:
      'Die Podiumsplatte ist betoniert, die Turmkerne wachsen. Der nächste Baufortschritt löst eine Rate aus; wir gleichen ihn vor Fälligkeit mit dem DLD-Projektregister ab — Sie zahlen nie für einen Fortschritt, den der Bau noch nicht erreicht hat.',
    imageUrls: ['https://i.imgur.com/HhXIcMP.jpeg'],
    actionLabel: null,
    actionUrl: null,
    actionLabel2: null,
    actionUrl2: null,
    commentsEnabled: true,
    pinned: false,
    likes: [],
    comments: [],
    viewCount: 61,
    createdAt: daysAgo(9),
  },
  {
    id: 'demo-post-update-seagate',
    type: 'update',
    author: 'Asset Desk · Property Management',
    title: 'Seagate Building 2 · 1204 — mid-term inspection passed',
    titleDe: 'Seagate Building 2 · 1204 — Zwischenprüfung bestanden',
    content:
      'Our mid-term inspection found no structural issues. AC filters were replaced and the balcony sealant is logged for review at renewal. The report and photographs are filed against the unit under Documents.',
    contentDe:
      'Unsere Zwischenprüfung ergab keine baulichen Mängel. Die Klimafilter wurden gewechselt, die Balkonabdichtung ist für die Prüfung bei Verlängerung vermerkt. Bericht und Fotos liegen bei der Einheit unter Dokumente.',
    imageUrls: ['https://i.imgur.com/Wq09VFd.jpeg'],
    actionLabel: null,
    actionUrl: null,
    actionLabel2: null,
    actionUrl2: null,
    commentsEnabled: true,
    pinned: false,
    likes: [],
    comments: [],
    viewCount: 88,
    createdAt: daysAgo(12),
  },
];
